import React from 'react';
import coverbackground from '../../assets/arctic-min.jpg';
import ReusableMetricCard from '../../components/ReusableMetriccard/ReusableMetriccard';
import Dn from '../../assets/dn.png';

class ScrollIcemin extends React.Component {
  render () { 
   return(
  
  <ReusableMetricCard             
    
        
        description="Arctic Ice Min."
        trend={Dn}
        metriclg="12.85%"
        metricsm="per decade"
        coverbackground={coverbackground}
     />
  
  );
 }
}   

export default ScrollIcemin;